import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink, useNavigate } from 'react-router-dom';
import { Table, Button, notification, Popconfirm } from 'antd';
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import { PageContainer } from '@ant-design/pro-layout';
import { storage } from 'helpers';
import { removeProperty } from 'helpers/utils';
import { AuthContext } from 'context/AuthContext';
import userService from 'services/user.service';
import merchService from 'services/merch.service';
import AddForm from './components/AddForm';
import EditForm from './components/EditForm';
import CheckAuth from '../../components/common/CheckAuth';
import authorities from '../../helpers/authorities';

const withRouter = (WrappedComponent) => {
  return (props) => {
    const navigate = useNavigate();
    return <WrappedComponent {...props} navigate={navigate} />;
  };
};

class MyMerchs extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      loading: false,
      submitting: false,
      visibleAdd: false,
      visibleEdit: false,
      error: null,
      selectedMerch: null,
      columns: [
        {
          title: 'Numara Tipi',
          dataIndex: 'type',
          key: 'type',
          align: 'center',
        },
        {
          title: 'Numara',
          dataIndex: 'number',
          key: 'number',
          align: 'center',
        },
        {
          title: 'Yetkili Kişi',
          dataIndex: 'contactName',
          key: 'contanctName',
          align: 'center',
        },
        {
          title: 'İletişim Maili',
          dataIndex: 'contactEmail',
          key: 'contanctEmail',
          align: 'center',
        },
        {
          title: 'İletişim Numarası',
          dataIndex: 'contactGsm',
          key: 'contanctGsm',
          align: 'center',
        },
        {
          title: 'E-Arşiv Maili',
          dataIndex: 'emailForArchive',
          key: 'emailForArchive',
          align: 'center',
        },
        {
          title: 'İşlemler',
          dataIndex: 'identifier',
          key: 'actions',
          fixed: 'right',
          align: 'center',
          width: 150,
          render: (id, record) => (
            <>
              <CheckAuth authorityCode={authorities.UPDATE_MERHANT_INFO} key="1">
                <NavLink to={`/is-yeri-bilgilerim/duzenle/${record.number}`}>
                  <Button type="ghost">
                    <EditOutlined />
                  </Button>
                </NavLink>
              </CheckAuth>

              <CheckAuth authorityCode={authorities.DELETE_MERHANT_INFO}>
                <Popconfirm
                  title="Üye işyerini çıkarmak istediğinize emin misiniz?"
                  okText="Evet"
                  cancelText="Hayır"
                  onConfirm={async () => {
                    await this.deleteMerch(id);
                  }}
                  placement="topRight"
                >
                  <Button className="ml-3" type="danger">
                    <DeleteOutlined />
                  </Button>
                </Popconfirm>
              </CheckAuth>
            </>
          ),
        },
      ],
    };
  }

  handleSubmitAddForm = async (values) => {
    try {
      const { updateCurrentUser, currentUser } = this.context;
      this.setState({ submitting: true, loading: true });
      const removedKeys = removeProperty('keys');
      const removedBody = removedKeys(values);
      const body = {
        parentAccountId: currentUser.identifier,
        email: currentUser.email,
        roleId: '',
        identityNumberList: removedBody?.identityNumberList || [],
      };
      /* identityNumberList: [
        ...currentUser?.merchantInfos.map(item => ({ number: item.number, type: item.type })),
        ...removedBody?.identityNumberList,
      ],
      */

      await userService.updateUser(currentUser.identifier, body);
      updateCurrentUser();
      notification.success({
        message: 'İşlem Başarılı',
        description: 'Üye işyeri eklendi.',
      });
      this.setState({ submitting: false, error: null, loading: false });
      this.handleCloseAddForm();
    } catch (error) {
      this.setState({ submitting: false, error, loading: false });
    }
  };

  handleSubmitEditForm = async (values) => {
    try {
      const { selectedMerch } = this.state;
      const { updateCurrentUser, selectedMerch: contextSelectedMerch } = this.context;
      this.setState({ loading: true });
      const body = {
        ...values,
        email: selectedMerch.email,
      };
      await merchService.updateMerch(selectedMerch.identifier, body);
      updateCurrentUser();
      notification.success({
        message: 'İşlem Başarılı',
        description: 'Üye işyeri güncellendi.',
      });
      if (selectedMerch.identifier === contextSelectedMerch.identifier)
        storage.set({ ...contextSelectedMerch, ...values }, 'selectedMerch');
      this.setState({ loading: false, error: null });
      this.handleCloseEditForm();
    } catch (error) {
      notification.error({
        message: 'İşlem Başarısız',
        description: error,
      });
      this.setState({ loading: false, error });
    }
  };

  deleteMerch = async (merchId) => {
    try {
      const { currentUser, updateCurrentUser } = this.context;
      const userId = currentUser?.identifier;
      this.setState({ loading: true });
      await merchService.deleteMerch(userId, merchId);
      updateCurrentUser();
      notification.success({
        message: 'İşlem Başarılı',
        description: 'Üye işyeri çıkarıldı.',
      });
      this.setState({ error: null, loading: false });
    } catch (error) {
      this.setState({ error: null, loading: false });
      notification.error({
        message: 'İşlem Başarısız',
        description: error.message || error,
      });
    }
  };

  handleOpenAddForm = () => {
    this.setState({ visibleAdd: true });
  };

  handleCloseAddForm = () => {
    this.setState({ visibleAdd: false, error: null });
  };

  handleCloseEditForm = () => {
    this.setState({ visibleEdit: false, error: null });
  };

  render() {
    const { columns, loading, error, submitting, visibleAdd, visibleEdit, selectedMerch } =
      this.state;
    const { currentUserMerchs, loading: merchLoading } = this.context;

    const { navigate } = this.props;
    return (
      <PageContainer
        title="Üye İşyerlerim"
        subTitle="Size ait üye işyerleri listelenmektedir."
        onBack={() => navigate(-1)}
        extra={[
          <CheckAuth authorityCode={authorities.ADD_MERHANT_INFO} key="1">
            <Button
              disabled={loading}
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => {
                this.handleOpenAddForm();
              }}
            >
              Ekle
            </Button>
          </CheckAuth>,
        ]}
      >
        <Table
          loading={merchLoading}
          dataSource={currentUserMerchs}
          columns={columns}
          pagination={false}
          rowKey="identifier"
        />
        {visibleAdd && (
          <AddForm
            submitting={submitting}
            error={error}
            visible={visibleAdd}
            handleCloseForm={this.handleCloseAddForm}
            handleSubmitForm={this.handleSubmitAddForm}
          />
        )}
        {visibleEdit && (
          <EditForm
            selectedMerch={selectedMerch}
            submitting={submitting}
            error={error}
            visible={visibleEdit}
            handleCloseForm={this.handleCloseEditForm}
            handleSubmitForm={this.handleSubmitEditForm}
          />
        )}
      </PageContainer>
    );
  }
}

MyMerchs.contextType = AuthContext;

MyMerchs.propTypes = {
  navigate: PropTypes.func.isRequired,
};

export default withRouter(MyMerchs);
